{
  "sdk-download-android": "Descărcați pentru Android",
  "sdk-connect": "Conectare",
  "sdk-download-ios": "Descărcați pentru iOS",
  "sdk-install": "Instalați",
  "sdk-modal-instruct-1": "1. Deschideți aplicația Binance",
  "sdk-modal-instruct-2": "2. Atingeți {{icon}} pe ecranul de pornire",
  "sdk-modal-title": "Conectați-vă cu Binance",
  "sdk-no-app": "Nu aveți încă aplicația Binance?"
}